import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import moment from 'moment';

export default class ReturnTableList extends Component {
  render(){
    return (
      <table className="table table-striped table-bordered datatable mb-0">
        <thead>
          <tr>
            <th>Id</th>
            <th>Shipment</th>
            <th className="hidden-xxs-down">Customer</th>
            <th className="hidden-xs-down">Date Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <ReturnList returns={this.props.list}/>
      </table>
    )
  }
};

const ReturnTableRow = (props) => {
    let date = props.return ? moment(props.return.created_at).format('L') : '';
    return(
      <tr>
        <td>{props.return ? 
          <NavLink to={`/return/${props.return.id}`}>{props.return.id}</NavLink>
           : ''}</td>
        <td>
          <NavLink to={`/shipment/${props.return.shipment_data.id}`}>
            {props.return.shipment_data.id}
          </NavLink>
        </td>
        <td className="hidden-xxs-down">{props.return.shipment_data.destination.name}</td>
        <td className="hidden-xs-down">{date}</td>
        <td>
          <NavLink to={`/return/${props.return.id}`} className="btn-sm btn-info">
            <i className="fa fa-eye"></i>
          </NavLink>
        </td>
      </tr>
    )
};

const ReturnList = (props) => {
  return (
    <tbody>
      {props.returns.map((r, idx) => {
          return <ReturnTableRow return={r} key={idx}/>
        })
      }
    </tbody>
  );
};
